/**
 * The one place that turns composer content into the body an SMS actually
 * carries. Every segment counter must measure this and nothing else: counting
 * the editor's markup prices tags as characters, and counting before
 * sanitization prices a curly quote as UCS-2 when the send folds it to an
 * apostrophe. Both mistakes report segments the customer is never billed for.
 */

import { expandTemplateChips, htmlToMultilineText } from './html'
import { sanitizeSmsText } from './sms-sanitize'

/** Cheap guard so a chip-free draft skips the extra parse on every keystroke. */
const CHIP_ATTR = 'data-template-variable'

/**
 * Rich-editor HTML → the wire body, in the send path's own order: template
 * chips expand to the `{{token}}` the server renders per recipient, paragraph
 * and `<br>` boundaries become newlines, then fancy Unicode folds to plain
 * text. A plain-text field (a textarea) has no markup to flatten and calls
 * `sanitizeSmsText` directly.
 */
export function smsBodyFromHtml(html: string): string {
  const expanded = html.includes(CHIP_ATTR) ? expandTemplateChips(html) : html
  return sanitizeSmsText(htmlToMultilineText(expanded))
}
